<template>
  <div class="clinicservicedetail">
    <b-container fluid>
      <b-row class="mycontainer-main">
        <b-col cols="12" md="4" class="pl-5 leftcontent" :style="{
          backgroundImage:
            'linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.3)), url(' +
            this.img +
            ')',
        }">
          <h1>{{ service }}</h1>
          <b-button squared variant="outline-light" class="mt-3" @click="goBack">
            {{ $t("common.goback") }}
          </b-button>
          <appt-button v-bind:color="'l'" />
        </b-col>

        <b-col cols="12" md="4" class="">
          <b-card class="shadow">
            <b-card-title style="font-weight: bold">
              {{ $t("common.description") }}</b-card-title>
            <!-- <b-card-text >what to expect during your experience</b-card-text>                             -->
            <b-card-text> {{ serviceDisplay.desc }} </b-card-text>
            <!-- <b-button squared style="background-color: black;" class="main-button" v-b-toggle="'desc'"> Details  </b-button>                          
                                <b-collapse id="desc" class="mt-3">
                                    <p> {{serviceDisplay.desc}} </p>
                                </b-collapse>                         -->
          </b-card>
          <b-card class="shadow">
            <b-card-title style="font-weight: bold">{{
          $t("common.types")
        }}</b-card-title>
            <!-- <b-card-text >what kinds of treatments we offer</b-card-text>                               -->
            <br />
            <b-list-group flush>
              <b-list-group-item v-for="(e, index) in serviceDisplay.types" :key="index">
                {{ e }}</b-list-group-item>
            </b-list-group>
            <!-- <b-button squared style="background-color: black;" class="main-button" v-b-toggle="'type'"> Details  </b-button>                           -->
            <!-- <b-collapse id="type" class="mt-3">
                                <ul>
                                        <li v-for="(e,index) in serviceDisplay.types" :key="index" > {{e}}</li>
                                    </ul>
                                </b-collapse>                              -->
          </b-card>

          <b-card v-if="serviceDisplay.showtouchless === true" style="background-color: black; color: white"
            text-variant="white" class="align-self-end shadow">
            <b-card-title style="font-weight: bold">{{ $t("touchlessfacial.title") }}
            </b-card-title>
            <b-card-text style="color: white">{{ $t("touchlessfacial.description") }}
            </b-card-text>
            <br />
            <b-button squared variant="outline-light" href="/clinic/services/">
              {{ $t("common.learn-more") }}
            </b-button>
          </b-card>
        </b-col>
        <b-col cols="12" md="4" class="">
          <b-card class="shadow">
            <b-card-title style="font-weight: bold">{{
          $t("common.howtoprepare")
        }}</b-card-title>
            <!-- <b-card-text >what to do before your visit</b-card-text>                               -->
            <br />
            <b-button squared style="background-color: black" class="main-button" v-b-toggle="'prep'">
              {{ $t("common.details") }}
            </b-button>
            <b-collapse id="prep" class="mt-3">
              <ul>
                <li v-for="(e, index) in serviceDisplay.prepare" :key="index">
                  {{ e }}
                </li>
              </ul>
            </b-collapse>
          </b-card>

          <b-card class="shadow">
            <b-card-title style="font-weight: bold">{{
          $t("common.cost")
        }}</b-card-title>
            <!-- <b-card-text >what you expect to pay</b-card-text>                               -->
            <br />
            <b-button squared style="background-color: black" class="main-button" v-b-toggle="'cost'">
              {{ $t("common.details") }}
            </b-button>
            <b-collapse id="cost" class="mt-3">
              <p>{{ serviceDisplay["cost"] }}</p>
            </b-collapse>
          </b-card>

          <b-card class="shadow">
            <b-card-title style="font-weight: bold">{{
          $t("common.extras")
        }}</b-card-title>
            <!-- <b-card-text >what else can you add</b-card-text>                               -->
            <br />
            <b-button squared style="background-color: black" class="main-button" v-b-toggle="'extra'">
              {{ $t("common.details") }}
            </b-button>
            <b-collapse id="extra" class="mt-3">
              <ul>
                <li v-for="(e, index) in serviceDisplay.extras" :key="index">
                  {{ e }}
                </li>
              </ul>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
const endata = [
  {
    name: "Facials",
    img: "s_facial",
    desc: "Unique experience in Quebec city, results, passion and expertise",
    types: [
      "Classic",
      "Hydration",
      "Anti-Aging",
      "Sensitive skin",
      "Teenager",
      "Acne facial",
    ],
    cost: "Prices vary around 105 to 165$",
    extras: [
      "microdermabrasion",
      "peeling",
      "needleless mesotherapy",
      "eye-lip treatment",
    ],
    prepare: [
      "Step 1: Complete the form about your skin concerns",
      "step 2: Choose the type of facial you would like to receive with your esthetician",
      "step3 Get ready to be pampered",
    ],
    showtouchless: false,
  },
  {
    name: "Peelings",
    img: "s_peeling",
    desc: "The variety of peelins offered at Beaute Integrale are focused on delivering a clinically proven anti-aging results.",
    types: ["Retinol", "Glyco 10", "Acid Peel 20%"],
    cost: "Prices are 125$ per peeling",
    extras: ["There is no extra that can be added to the peelings"],
    prepare: [
      "Step 1: Complete the form about your skin concerns",
      "step 2: Choose the type of facial you would like to receive with your esthetician",
      "step3 Get ready to be pampered",
    ],
    showtouchless: false,
  },
  {
    name: "Photofacial",
    img: "s_photofacial",
    desc: "BBL BroadBand Light is the world’s most powerful IPL device on the market. It sets new standards in treating skin conditions associated with aging, active life styles and sun damage. ",
    types: ["Local treatement", "Full face", "Full face, neck and hands"],
    cost: "Prices may vary from 100$ to 300$",
    extras: [
      "There is no extra that can be added to the photofacial treatments",
    ],
    prepare: [
      "Step 1: Complete the form about your skin concerns",
      "step 2: Choose the type of photofacial you would like to receive with your esthetician trhough a live or online consultation",
      "step3: Get ready to receive your photofacial treatment",
    ],
    showtouchless: false,
  },
  {
    name: "Microdermabrasion",
    img: "s_microderm",
    desc: 'Recommended at each change of season, this complete "deep cleaning" treatment is designed to work the entire face, even in the smallest roots. Thanks to the corundum sandblasting technique, the skin will be freed of its impurities, regenerated and renewed.',
    types: ["Addition to your selected facial", "Microdermabrasion only"],
    cost: "prices may vary around 52.50$ to 85$",
    extras: ["Mask", "extraction", "massage"],
    prepare: [
      "Step 1: Complete the form about your skin concerns",
      "step 2: Choose the type of facial you would like to receive with your esthetician",
      "step3 Get ready to be pampered",
    ],
    showtouchless: false,
  },
  {
    name: "Hair Removal",
    img: "s_hairremoval",
    desc: "Beaute Integrale offers a variety of ways to get rid of hair, from the most traditional techniques to the most advanced and definitive",
    types: [
      "BBL Definitive hair removal",
      "Electrolysis by microcurrents ",
      "Wax and Soy",
    ],
    cost: "Prices may vary for different body areas",
    extras: [
      "There is no extras that can be added to the different types of hair removal",
    ],
    prepare: [
      "step 1: Meet an technician online or face-to-face to determine the areas of treatments, get the explanations of preparation for your first treatment and determine if you are a candidate",
      "step 2: Get ready for your first treatment",
    ],
    showtouchless: false,
  },
  {
    name: "Microneedling",
    img: "s_microneedling",
    desc: "The InnoPen was recognized as the best professional tool for skin rejuvenation. This revolutionary system is the ultimate in-clinic solution for treatments. InnoPen represents the technology of the future, it corrects the harmful effects of time on the skin while delaying the aging process. InnoPen is the most advanced device in its class and the safest for micro-perforation of the skin. It is an innovative instrument that is used in mesotherapy. ",
    types: [
      "Scars",
      "Stretch marks",
      "Fine lines and wrinkles",
      "Acne marks",
      "Hair restoration",
    ],
    cost: "Prices may vary depending on the region treated $ 275 to $ 300 + tx",
    extras: ["There are no extras associated with mesotherapy treatments"],
    prepare: [
      "Step 1: Complete the concerns about your skin form",
      "Step 2: Choose the type of photofacial that best suits your problem with your esthetician via an online or in-person consultation. The consultation is essential to assess whether you are a candidate for treatment and that there are no contraindications. ",
      " Step 3: Be ready for your mesotherapy treatment ",
    ],
    showtouchless: false,
  },
  {
    name: "Hydrafacial",
    img: "s_hydrafacial",
    desc: "The unique experience of Hydrafacial treatment, more than a facial, it is a hydrafacial.",
    types: [
      "Signature",
      "Deluxe",
      "Platinum",
      "Lip Perk",
      "Eye Perk"

    ],
    cost: "Prices can vary from $199 to $325 +tx. It is possible to make additional additions (see the section improving your care)",
    extras: [
      "Lip Perk",
      "Eye Perk ",
      "Neck/Chest",
      "Body/back/arms",
      "Hands"
    ],
    prepare: [
      "Step 1: Complete the health and skin concern questionnaire",
      "Step 2: Choose the facial that is most appropriate for your skin with your beautician",
      "Step 3: Be ready for the great experience of results and relaxation!"
    ],
    showtouchless: false,
  },
];

const frdata = [
  {
    name: "Les soins du visage",
    img: "s_facial",
    desc: "L’unique expérience du soin du visage à Québec. Résultats, passion et expertise",
    types: [
      "Le Classique",
      "Hydratation profonde",
      "Anti-Âge",
      "Peaux sensibles et réactives",
      "Adolescent",
      "Acné et imperfections",
    ],
    cost: "Les prix peuvent varier de 105 à 165$",
    extras: [
      "Microdermabrasion",
      "Peeling",
      "Mésothérapie sans aiguilles",
      "Yeux-Lèvres",
    ],
    prepare: [
      "Étape 1: Complétez le questionnaire sur vos préoccupations à l’égard de votre peau",
      "Étape 2: Choisissez le facial qui est le plus approprié pour votre peau avec votre esthéticienne",
      "Étape 3: Soyez prêts pour la grande expérience de résultats et détente!",
    ],
    showtouchless: false,
  },
  {
    name: "Les Peelings",
    img: "s_peeling",
    desc: "La variété de différents peelings offerts chez Beauté Intégrale sont à l’avant garde sur les résultats cliniques anti-âge.",
    types: ["Retinol", "Glyco 10", "Peeling acide 20%", "MEline"],
    cost: "Les prix pour les peelings sont à partir de 129$ + tx",
    extras: ["Il n’y a pas d’extras associés aux peelings"],
    prepare: [
      "Étape 1: Complétez le formulaire sur vos préoccupations à l’égard de votre peau",
      "Étape 2: Choisissez le peeling qui est le plus approprié pour votre peau avec votre esthéticienne",
      "Étape 3: Soyez prêts pour la grande expérience du peeling!",
    ],
    showtouchless: false,
  },
  {
    name: "Photofacial",
    img: "s_photofacial",
    desc: "BBL BroadBand Light est l’appareil IPL le plus puissant de sa catégorie sur le marché. Il créé les nouveaux standards pour le traitement des conditions de la peau associées à l’âge, les styles de vie actifs et les dommages causés par le soleil.",
    types: [
      "Traitement local",
      "Traitement visage complet",
      "Traitement visage complet, cou et mains",
    ],
    cost: "Les prix peuvent varier en fonction de la région traitée 100$ à 300$",
    extras: ["Il n’y a pas d’extras associés aux traitements de photofacial"],
    prepare: [
      "Étape 1: Complétez le formulaire de préoccupations à l’égard de votre peau",
      "Étape 2: Choisissez le type de photofacial qui convient le plus à votre problématique avec votre esthéticienne via une consultation en ligne ou en personne. La consultation est primordiale pour évaluer si vous êtes candidat(e) à recevoir le traitement et qu’il n’y a aucune contre-indications.",
      "Étape 3: Soyez prêts à recevoir votre traitement de photofacial",
    ],
    showtouchless: false,
  },
  {
    name: "Microdermabrasion",
    img: "s_microderm",
    desc: "Recommandé à chaque changement de saison, ce soin “Grand ménage” complet est conçu pour travailler l’ensemble du visage jusque dans les plus petits racoins. Grâce à la technique du sablage au corindon, la peau se trouvera libérée de ses impuretés, régénérée et renouvelée.",
    types: [
      "Microdermabrasion en ajout à votre soin du visage",
      "Microdermasion seule",
    ],
    cost: "Les prix peuvent varier de 52.50$ (en ajout à votre soin) à 85$ (seule)",
    extras: ["Masque", "Extraction", "Massage"],
    prepare: [
      "Étape 1: Complétez le formulaire des préoccupations à l’égard de votre peau",
      "Étape 2: Choisissez le type de microdermabrasion que vous voudriez recevoir avec votre esthéticienne",
      "Étape 3: Soyez prêt(e) à recevoir votre microdermabrasion",
    ],
    showtouchless: false,
  },
  {
    name: "Épilation",
    img: "s_hairremoval",
    desc: "Beauté Intégrale offre une large sélection de traitements pour se débarasser des poils indésirables. Des techniques plus traditionnelles aux techniques les plus avancées et définitives.",
    types: [
      "Épilation définitive par BBL",
      "Électrolyse par micro-courants",
      "Cire et Soya",
    ],
    cost: "Les prix peuvent varier en fonction des régions du corps traitées",
    extras: [
      "Il n’y a pas de suppléments associés aux techniques d’épilation et d’épilation définitive",
    ],
    prepare: [
      "Étape 1: Rencontrez une esthéticienne en ligne ou en personne pour déterminer les régions que vous voulez traiter. Recevez les explications et vos instructions de préparation pour votre premier traitement. La consutlation est primordiale pour déterminer si vous êtes candidat(e) à recevoir des traitements d’épilation définitive et qu’il n’y ait pas de contre-indications",
      "Étape 2: Soyez prêts à recevoir votre premier traitement d’épilation traditionnelle ou définitive!",
    ],
    showtouchless: false,
  },
  {
    name: "Microneedling",
    img: "s_microneedling",
    desc: "L’ InnoPen fut reconnu comme étant le meilleur instrument professionnel pour le rajeunissement cutané. Ce système révolutionnaire est la solution ultime en clinique pour des traitements. L’ InnoPen  représente la technologie de l’avenir, il corrige les effets néfastes du temps sur la peau tout en retardant le processus du vieillissement. InnoPen est le dispositif le plus avancé de sa catégorie et le plus sécuritaire en matière de micro- perforation de la peau. Il est un instrument innovant que l’on utilise en mésothérapie.",
    types: [
      "Cicatrices",
      "Vergetures",
      "Rides et ridules",
      "Traces d'acné",
      "Restauration des cheveux",
    ],
    cost: "Les prix peuvent varier en fonction de la région traitée 275$ à 300$ + tx",
    extras: ["Il n’y a pas d’extras associés aux traitements de mésothérapie"],
    prepare: [
      "Étape 1: Complétez le formulaire de préoccupations à l’égard de votre peau",
      "Étape 2: Choisissez le type de photofacial qui convient le plus à votre problématique avec votre esthéticienne via une consultation en ligne ou en personne. La consultation est primordiale pour évaluer si vous êtes candidat(e) à recevoir le traitement et qu’il n’y a aucune contre-indications.",
      "Etape 3: Soyez prêts à recevoir votre traitement de mésothérapie",
    ],
    showtouchless: false,
  },
  {
    name: "Hydrafacial",
    img: "s_hydrafacial",
    desc: "L’unique expérience du soin Hydrafacial, plus qu’un facial, c’est un hydrafacial. ",
    types: [
      "Le Signature",
      "Le Deluxe",
      "Le Platine",
      "Le Lip Perk",
      "Le Eye Perk"

    ],
    cost: "Les prix peuvent varier de 199$ à 325$ +tx.  Il est possible de faire des ajouts supplémentaires (voir la section bonifier votre soin)",
    extras: [
      "Lip Perk",
      "Eye Perk ",
      "Cou et décolleté",
      "Corps/dos/bras",
      "Mains"
    ],
    prepare: [
      "Étape 1: Complétez le questionnaire de santé et sur vos préoccupations à l’égard de votre peau",
      "Étape 2: Choisissez le facial qui est le plus approprié pour votre peau avec votre esthéticienne",
      "Étape 3: Soyez prêts pour la grande expérience de résultats et détente!"
    ],
    showtouchless: false,
  },
];

export default {
  name: "clinicservicedetail",
  prop: ["service-name"],
  data() {
    return {
      msg: "Welcome to BI",
      serviceDisplay: "",
      serviceDetailList: "",
      img: "",
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getData() {
      if (this.$i18n.locale == "fr") {
        this.serviceDetailList = frdata;
        var x = this.serviceDetailList.filter(
          (item) => item.name === this.service
        );
        this.serviceDisplay = x[0];
      } else this.serviceDetailList = endata;
      var x = this.serviceDetailList.filter(
        (item) => item.name === this.service
      );
      this.serviceDisplay = x[0];
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    service() {
      return this.$route.params.service;
    },
  },
  mounted() {
    this.getData();
    this.img = require("../assets/images/services/" +
      this.serviceDisplay.img +
      ".jpg");
  },
  watch: {
    locale: function (newLocale, oldLocale) {
      this.getData();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mycontainer-main {
  min-height: 90vh;
}

.leftcontent {
  color: white;
  padding-top: 30vh;
  padding-bottom: 10vh;
  /* background-image: linear-gradient(rgba(0, 0, 0, 0.5),
                       rgba(0, 0, 0, 0.3)), url('../assets/images/retail-clinic.jpg'); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

/* .card-columns {
    column-count: 2;
} */
/* @media (max-width: 576px) {
    .card-columns {
        column-count: 1;
    }
} */
.card {
  margin: 5px 0 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ClinicServiceDetail.vue